var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["columnCount", "displayStyle", "className", "children", "placeholder"], _excluded2 = ["className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React, { Children, forwardRef } from "react";
import { Carousel } from "@riseart/antd-provider";
import { SETTINGS } from "./settings";
import { sliderCls, sliderHorizontalCls, sliderPlaceholderCls, sliderItemCls, sliderDotsCls } from "./Slider.less";
var HorizontalSlider = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var _ref$columnCount = _ref.columnCount, columnCount = _ref$columnCount === void 0 ? "3" : _ref$columnCount, _ref$displayStyle = _ref.displayStyle, displayStyle = _ref$displayStyle === void 0 ? "1" : _ref$displayStyle, customClassName = _ref.className, children = _ref.children, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? false : _ref$placeholder, customSliderProps = _objectWithoutProperties(_ref, _excluded);
  if (!SETTINGS[columnCount] || !SETTINGS[columnCount].styles || !SETTINGS[columnCount].styles[displayStyle]) {
    throw new Error("[@riseart/slider] Invalid settings provided to slider");
  }
  var _SETTINGS$columnCount = SETTINGS[columnCount].styles[displayStyle], typeClassName = _SETTINGS$columnCount.className, sliderSettings = _objectWithoutProperties(_SETTINGS$columnCount, _excluded2);
  var classNames = [sliderCls, sliderHorizontalCls, typeClassName, placeholder && sliderPlaceholderCls, customClassName].filter(function(className) {
    return !!className;
  }).join(" ");
  return /* @__PURE__ */ React.createElement(Carousel, _extends({
    ref,
    arrows: true,
    dots: {
      className: sliderDotsCls
    }
  }, sliderSettings, customSliderProps, {
    className: classNames
  }), Children.map(children, function(child) {
    return /* @__PURE__ */ React.createElement("div", {
      className: sliderItemCls
    }, child);
  }));
});
export {
  HorizontalSlider
};
